import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SectionTitle from '@/components/base/SectionTitle';
import { getHotRanking, formatHeat, typeLabel } from '@/utils/media';

export default function HotRanking() {
  const { t } = useTranslation();
  const ranking = getHotRanking(8);

  return (
    <section className="mx-auto max-w-page px-4 py-12 md:px-6 md:py-16">
      <SectionTitle icon="ri-fire-line" title={t('hotRanking')} desc={t('latestDesc')} />
      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
        <ul className="divide-y divide-background-200">
          {ranking.map((item, i) => (
            <li key={item.id}>
              <Link
                to={`/detail/${item.id}`}
                className="flex items-center gap-4 px-4 py-3 transition hover:bg-background-100 cursor-pointer md:px-5"
              >
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                    i < 3 ? 'bg-accent-500 text-accent-950' : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {i + 1}
                </span>
                <div className="relative h-14 w-10 shrink-0 overflow-hidden rounded bg-background-200 md:h-16 md:w-12">
                  <img
                    src={item.cover}
                    alt={`${item.title}封面`}
                    title={`${item.title} ${typeLabel(item.type)} 热播榜`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h4 className="line-clamp-1 font-heading text-sm font-semibold text-foreground-950 md:text-base">
                    {item.title}
                  </h4>
                  <p className="mt-0.5 line-clamp-1 text-xs text-foreground-500">
                    {typeLabel(item.type)} · {item.genres.join(' · ')} · {item.year}
                  </p>
                </div>
                <div className="hidden shrink-0 items-center gap-4 text-xs text-foreground-500 sm:flex">
                  <span className="flex items-center gap-1 font-semibold text-accent-600">
                    <i className="ri-star-fill text-[11px]"></i>
                    {item.rating.toFixed(1)}
                  </span>
                  <span className="flex w-20 items-center justify-end gap-1">
                    <i className="ri-fire-fill text-accent-400"></i>
                    {formatHeat(item.heat)}
                  </span>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}